import styled from 'styled-components'
import {Col, Row, Card} from 'antd'
import { device } from '../../styles/devices';

export const TituloMenu = styled.h1`
  font-size: 20px;
  text-align: center;
  letter-spacing:2px;
  color: black;
  margin:0;
  padding:0;
  font-weight:400;
 
  @media ${device.laptop} { 
    font-size: 40px;
  }

  @media ${device.mobileL} { 
    font-size: 25px;
  }
`;

export const ColFlex= styled(Col)`
  display:flex;
  justify-content:center;
  align-items:center;
  box-sizing: border-box;
  margin-top:2em;
`;

export const RowStyle= styled(Row)`
   margin: 2em 0 2em 0;
`;

export const DivPedidoContenido = styled.div`
  font-size: 14px;
  letter-spacing:1px;
  color: black;
  font-weight:bold;
  span{
    color:#283c63;
  }
`;

export const CardCliente=styled(Card)`
   height:"200px";
   background:"#455323";

  @media ${device.laptop} { 
    height:"200px";
  }

  @media ${device.mobileL} { 
    font-size: 25px;
  }
`;

export const DivFlexbox = styled.div`
  display:flex;
  justify-content:space-around;
  align-items:center;
  flex-wrap:wrap;
  a{
    display:flex;
    flex-direction:column;
    justify-content:space-around;
    align-items:center;
    font-size:20px;
    font-weight:bold
  }
  a img{
    width:50%;
  }
`;